import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { IAction, IApiList, IPaymentSet } from 'types';
import * as API from '../../../api';
import * as Actions from './actions';
import { IGetSitePaymentsPayload, Payments } from './types';

export function* getSitePaymentSets({ payload }: IAction<Payments, IGetSitePaymentsPayload>): any {
  try {
    const { siteId, options } = payload;
    const response: ApiResponse<IApiList<IPaymentSet>> = yield call(API.Sites.getSitePayments, siteId, options);

    yield put(Actions.getSitePaymentsSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getSitePaymentsError(error));
  }
}

export function* watchGetPaymentSets() {
  yield takeEvery(Payments.GET_SITE_PAYMENTS_REQUEST, getSitePaymentSets);
}

function* paymentsSagas() {
  yield all([fork(watchGetPaymentSets)]);
}

export { paymentsSagas };
